export default "__VITE_ASSET__$F9M2h$l__"